<script>
import FormItem from '@/components/FormItem'

export default {
  name: 'RadioGroup',

  components: {
    FormItem,
  },

  props: {
    // 'default' = layout clássico (ícone + label empilhável)
    // 'segmented' = trilho cinza do segmented control (pílula)
    variant: {
      type: String,
      default: 'default',
      validator: v => ['default', 'segmented'].includes(v),
    },
  },

  computed: {
    groupClasses () {
      return {
        [this.$classes['form-radio-group']]: true,
        [this.$classes['is-segmented']]: this.variant === 'segmented',
      }
    },
  },
}
</script>

<template>
  <form-item>
    <div :class="groupClasses">
      <slot />
    </div>
  </form-item>
</template>

<style module>
.form-radio-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: max-content;
}

/* Segmented control: trilho cinza que envolve os segmentos.
   Trilho um pouco mais escuro (#ECECEE) p/ separar do BaseCard branco. */
.form-radio-group.is-segmented {
  flex-wrap: nowrap;
  gap: 2px;
  padding: 3px;
  background: #ececee;
  border-radius: 8px;
}
</style>
